export default __webpack_public_path__ + "static/media/closet4-1920w.32b89796.webp";